module.exports = __webpack_public_path__ + "img/Modified Dashboard v2.21f1800c.png";